import classnames from 'classnames';
import React from 'react';

import { IconPlayButton132, IconPlayButton56 } from '@cineamo/ui/src/icons/ic-playButton';

import MobileOrDesktopRenderer from '../MobileOrDesktopRenderer';

const MovieTrailerPlayerButton: React.FC<{
    onPlay: () => void;
    className?: string;
    'aria-label'?: string;
}> = ({ onPlay, className, 'aria-label': ariaLabel }) => {
    return (
        <div className="absolute w-full h-full top-0 left-0 p-16 flex flex-row items-center">
            <div className="flex flex-auto items-center justify-center">
                <button
                    type="button"
                    className="pointer-events-auto bg-transparent border-none cursor-pointer p-0"
                    onClick={(event) => {
                        event.stopPropagation();
                        onPlay();
                    }}
                    aria-label={ariaLabel}>
                    <MobileOrDesktopRenderer
                        desktopContent={
                            <IconPlayButton132
                                className={classnames('text-black/50', className)}
                                foregroundcolor="white"
                                aria-hidden="true"
                            />
                        }
                        mobileContent={
                            <IconPlayButton56
                                className={classnames('text-black/50', className)}
                                foregroundcolor={'white'}
                                aria-hidden="true"
                            />
                        }
                    />
                </button>
            </div>
        </div>
    );
};

export default MovieTrailerPlayerButton;
